var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.realIntentions.length > 0
    ? _c(
        "div",
        {
          ref: "scrollTable",
          staticClass: "pega-scroll-table",
          on: { scroll: _vm.onScroll },
        },
        [
          _c(
            "table",
            { staticClass: "unstriped hover boss-table" },
            [
              _c("thead", [
                _c("tr", { attrs: { "data-test": "table-head" } }, [
                  _c(
                    "th",
                    {
                      staticClass: "boss-table-head-center",
                      attrs: { "data-test": "registration" },
                    },
                    [_vm._v("\n          登録内容\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      staticClass: "boss-table-head-center",
                      attrs: { "data-test": "registration-date" },
                    },
                    [_vm._v("\n          登録日\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      staticClass: "boss-table-head-center boss-update",
                      attrs: { "data-test": "update-date" },
                    },
                    [_vm._v("\n          更新日\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      staticClass: "boss-table-head-center boss-operation",
                      attrs: { "data-test": "update" },
                    },
                    [_vm._v("\n          編集\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      staticClass: "boss-table-head-center boss-operation",
                      attrs: { "data-test": "delete" },
                    },
                    [_vm._v("\n          削除\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      staticClass: "boss-table-head-center boss-operation",
                      attrs: { "data-test": "preview" },
                    },
                    [_vm._v("\n          プレビュー\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      staticClass: "boss-table-head-center boss-display-change",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "pega-relative",
                          attrs: { "data-test": "isPublished" },
                        },
                        [
                          _vm._v("\n            公開/非公開\n            "),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: {
                                    content:
                                      "公開すると、会員サイトに掲載されます。",
                                  },
                                  expression:
                                    "{ content: '公開すると、会員サイトに掲載されます。'}",
                                },
                              ],
                              staticClass: "pega-circle small-right-top",
                            },
                            [_vm._v("?")]
                          ),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _vm._l(_vm.realIntentions, function (realIntention) {
                return _c("real-intention-outline", {
                  key: realIntention.id,
                  attrs: { "real-intention": realIntention },
                  on: {
                    updated: _vm.updateObjects,
                    "update-display": _vm.updateDisplay,
                  },
                })
              }),
            ],
            2
          ),
        ]
      )
    : _c(
        "div",
        { staticClass: "grid-x grid-margin-y align-center margin-top-2" },
        [
          _c(
            "span",
            {
              staticClass: "cell medium-4 subheader",
              attrs: { "data-test": "no-data" },
            },
            [_vm._v("評判が登録されていません。")]
          ),
        ]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }